__turbopack_context__.v({
  "column": "socialProof-module-scss-module__N_C2-W__column",
  "container": "socialProof-module-scss-module__N_C2-W__container",
  "containerNew": "socialProof-module-scss-module__N_C2-W__containerNew",
  "content": "socialProof-module-scss-module__N_C2-W__content",
  "contentNew": "socialProof-module-scss-module__N_C2-W__contentNew",
  "cta": "socialProof-module-scss-module__N_C2-W__cta",
  "ctaNew": "socialProof-module-scss-module__N_C2-W__ctaNew",
  "eggshellBg": "socialProof-module-scss-module__N_C2-W__eggshellBg",
  "gap": "socialProof-module-scss-module__N_C2-W__gap",
  "header": "socialProof-module-scss-module__N_C2-W__header",
  "imageSection": "socialProof-module-scss-module__N_C2-W__imageSection",
  "imageSectionNew": "socialProof-module-scss-module__N_C2-W__imageSectionNew",
  "rating": "socialProof-module-scss-module__N_C2-W__rating",
  "ratingNew": "socialProof-module-scss-module__N_C2-W__ratingNew",
  "reviews": "socialProof-module-scss-module__N_C2-W__reviews",
  "socialProof": "socialProof-module-scss-module__N_C2-W__socialProof",
  "socialProofNew": "socialProof-module-scss-module__N_C2-W__socialProofNew",
  "star": "socialProof-module-scss-module__N_C2-W__star",
  "text": "socialProof-module-scss-module__N_C2-W__text",
  "textNew": "socialProof-module-scss-module__N_C2-W__textNew",
  "title": "socialProof-module-scss-module__N_C2-W__title",
  "titleNew": "socialProof-module-scss-module__N_C2-W__titleNew",
  "transparentBg": "socialProof-module-scss-module__N_C2-W__transparentBg",
});
